import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Paper, Container, Grid, TextField } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import { AlertBar } from "../Alert/AlertBar";
import { FiPlus } from "react-icons/fi";

import Header from "../CommonComps/Header";
import LoadingComponent from "../Loader";
import { styles } from "../Theme/Theme";
import {
  taxConfigurationEndpoint,
  taxGetByIdEndpoint,
  taxListEndpoint,
  tdsReportUrl,
} from "../config";
import { FcSearch } from "react-icons/fc";
import { getEncryptPayload } from "../Network_Utility";
import { userService } from "../userService";
import TdsTable from "./TdsTable";
import { themecolor } from "../Navigation";
import { checkPermissionExist } from "../utils";
import { IconButton, InputAdornment } from "@material-ui/core";
import IconTemplate from "../CommonComps/IconTemplate";

const transaction = require("../images/tax_reports.png");

const TDS_Report = ({ classes }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let reduxState = useSelector((val) => val?.rootReducer);
  let storedSite = reduxState?.siteReducer?.site;
  let companyDetail = reduxState?.loginReducer?.data;
  let accounts = reduxState?.accountReducer;
  let accountTypes = reduxState?.accountTypeReducer?.data;
  let endPoints = reduxState?.permissionReducer?.data;
  const siteList = reduxState?.sitesReducer?.data;
  // ================States=======================//
  const [loading, setLoading] = useState(false);
  const [taxData, setTaxData] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  //==================error====================//
  const [errors, setErrors] = useState([]);

  // ===========Alerts===================//
  const [alerts, setAlerts] = useState({
    visible: false,
    alertMessage: "",
    alertType: "",
  });

  // Function to show success alert
  const successAlert = (message) => {
    setAlerts({
      visible: true,
      alertMessage: message || "Data fetched succesfully",
      alertType: "success",
    });
    setLoading(false);
  };

  // Function to show error
  const errorAlert = (message) => {
    setAlerts({
      visible: true,
      alertMessage: message || "Something went wrong",
      alertType: "error",
    });
    setLoading(false);
  };

  const shortcutSearchRef = useRef(null);

  const iconTemplateArray = [
    {
      name: "Add Tax Section",
      isInputIcon: false,
      icon: <FiPlus />,
      function: (e) => readingDirection(e),
      style: {
        background: `${themecolor}`,
        color: "#fff",
        marginLeft: 10,
        display: checkPermissionExist(endPoints, taxConfigurationEndpoint)
          ? "inline-flex"
          : "none",
      },
    },
  ];

  function readingDirection(e) {
    navigate("/tax-configuration/tax-section");
  }

  //   enter key handle function
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setSearchValue(e.target.value);
      getTaxData();
    }
  };

  //Function to get TDS data
  const getTaxData = async () => {
    const payload = {};
    const encryptedPayload = getEncryptPayload(payload, true);

    setLoading(true);

    try {
      const res = await userService.postData(taxListEndpoint, encryptedPayload);

      if (res?.data?.status === 200 && res?.data?.data) {
        setTaxData(res.data.data);

        if (res.data.data.length > 0) {
          successAlert(res.data.message);
        } else {
          successAlert("No GST data available");
        }
      } else {
        errorAlert(res?.data?.message);
        setTaxData([]);
      }
    } catch (error) {
      errorAlert(error?.message);
      setTaxData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTaxData();
  }, []);

  // Function to close alert bar
  const closeAlertBar = () => setAlerts({ ...alerts, visible: false });
  return (
    <>
      <Paper
        className={classes.paper}
        elevation={0}
        style={{ width: "100%", overflow: "auto" }}
      >
        <Container style={{ maxWidth: "100%" }}>
          <Grid container style={{ margin: "0", alignItems: "center" }}>
            <Header
              gridSize="3"
              source={transaction}
              headerText="Tax Section"
            />
            <Grid
              item
              xs={9}
              container
              spacing={2}
              justifyContent="Flex-end"
              alignItems="center"
            >
              <Grid item>
                <TextField
                  inputRef={shortcutSearchRef}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  margin="dense"
                  size="small"
                  style={{
                    maxWidth: 200,
                    display: "inline-flex",
                  }}
                  label="Search"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => getTaxData()}
                        >
                          <FcSearch />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onKeyPress={(e) => handleKeyPress(e)}
                />
              </Grid>
              <Grid item>
                {iconTemplateArray && iconTemplateArray.length > 0 && (
                  <IconTemplate data={iconTemplateArray} />
                )}
              </Grid>
            </Grid>
          </Grid>
          <TdsTable
            {...{
              taxData,
            }}
          />
        </Container>
      </Paper>

      {/* ==============Alerts=============== */}
      <AlertBar
        visible={alerts?.visible}
        closeAlertBar={closeAlertBar}
        alertMessage={alerts?.alertMessage}
        alertType={alerts?.alertType}
      />

      {/* ==============Loader============= */}
      {loading && <LoadingComponent />}
    </>
  );
};
export default withStyles(styles)(TDS_Report);
